<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('dtp.add') }}</h1>
          <hr />
          <dtp-form :dense="false" />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import DtpForm from '../../components/dtp/DtpForm.vue';
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  components: { DtpForm },
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('car_accident_add', next);
  },
};
</script>

<style></style>
